<header>
    <h1 class="title-name">Central do Paciente</h1>
    <div class="header-logo">
        <div class="header-logo-content">
            <img *ngIf="isLogoUploaded" class="client-brand" [src]="this.clientLogo">
            <img *ngIf="!isLogoUploaded"class="client-brand" src="assets/images/logo-colorido.png">
        </div>
    </div>
</header>